export default {
  "name": "Head Guts Feet",
  "slug": "head-guts-feet",
  "path": "/head-guts-feet",
  "componentName" : "HeadGutsFeet",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}